<template>
  <div>
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"
              class="workflow-tabs">
              <input type="hidden" name="_token" :value="csrf">
              <input v-if="this.editing" type="hidden" name="_method" value="PUT">
              <div class="tab-content">
                <div class="row mb-3">
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.title") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[name]" :value="name">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.description") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[description]"
                        :value="description">
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label>{{ __("forms.Question.sorting") }}</label>
                      <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="sorting">
                    </div>
                  </div>
                </div>
                <div v-if="canEdit">
                  <div class="row">
                    <div class="col-12">
                      <p class="tab-description mt-3 mb-2">Workflow ruoli e persone</p>
                    </div>
                  </div>

                  <div class="alert alert-primary" role="alert">
                    {{ __("forms.Question.Elements.question38.info") }}
                  </div>
                  <div class="alert alert-warning" role="alert">
                    {{ __("forms.Question.Elements.question38.alert") }}
                  </div>

                  <div class="row align-items-center">
                    <div class="col-2">
                      <div class="form-group">
                        <label class="text-primary">
                          {{ __("forms.Question.Elements.question38.multi_evaluators_group_item") }}
                        </label>
                        <select class="form-control rounded" name="questionSettings[multi_evaluators_group_id]"
                          v-model="multi_evaluators_group_id" required>
                          <option v-for="row in multi_evaluators_group_list" :value="row.id" :key="'_id' + row.id">
                            {{ row.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <label class="text-primary">
                          {{ __("forms.Question.Elements.question38.workflow_set") }}
                        </label>
                        <select class="form-control rounded" name="questionSettings[workflow_set_role_id]"
                          v-model="workflow_set_role_id" required>
                          <option v-for="row in workflow_set_roles_list" :value="row.id" :key="row.id">
                            {{ row.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <label class="text-primary">
                          {{ __("forms.Question.Elements.question38.workflow_role") }}
                        </label>
                        <select class="form-control rounded" v-model="new_workflow_role_id">
                          <option v-for="wsr in workflow_roles_list[workflow_set_role_id]" :value="wsr.id"
                            :key="wsr.id">
                            {{ wsr.name }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-2">
                      <div class="form-group">
                        <label class="text-primary">
                          {{ __("forms.Question.Elements.question38.default_person_on_workflow_role") }}
                        </label>
                        <select class="form-control rounded" v-model="new_person_id">
                          <option v-for="person in people" :value="person.id" :key="'per_' + person.id">
                            {{ person.fullName }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <div class="col-4">
                      <div class="form-group">
                        <button type="button" class="btn float-right" @click="addRelation()">
                          {{ __("misc.add") }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-2">
                      <label class="text-primary">
                        {{ __("forms.Question.Elements.question38.workflow_role") }}
                      </label>
                    </div>
                    <div class="col-2">
                      <label class="text-primary">
                        {{ __("forms.Question.Elements.question38.default_person_on_workflow_role") }}
                      </label>
                    </div>
                  </div>
                  <div class="row mb-3" v-for="(wrp, index) in workflow_roles_people" :key="'wrp' + index">
                    <div class="col-2">
                      <select class="form-control rounded" v-model="wrp.workflow_role_id"
                        :name="'questionSettings[workflow_roles_people][' + index + '][workflow_role_id]'">
                        <option v-for="workflow_role in workflow_roles_list[workflow_set_role_id]"
                          :value="workflow_role.id" :key="'wrp' + workflow_role.id">
                          {{ workflow_role.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-2">
                      <select class="form-control rounded" v-model="wrp.person_id"
                        :name="'questionSettings[workflow_roles_people][' + index + '][person_id]'">
                        <option v-for="person in people" :value="person.id" :key="'pers_' + person.id">
                          {{ person.fullName }}
                        </option>
                      </select>
                    </div>
                    <div class="col-8">
                      <button type="button" class="btn btn--only-icon-rounded btn--danger float-right"
                        @click="deleteRow(index)"><i class="fas fa-times"></i></button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <hr>
                    </div>
                    <div class="col-12 mt-3 text-right" v-if="can_write">
                      <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                    </div>
                  </div>
                </div>
                <div v-else class="row">
                  <div class="col-12 col-md-4">
                    <div class="form-group">
                      <label class="text-primary">
                        {{ __("forms.multiEvaluatorsGroup.title") }}
                      </label>
                      <div v-for="melist in multi_evaluators_group_list" :key="melist.id">
                        <span v-if="melist.id == multi_evaluators_group_id">{{ melist.name }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="text-primary">
                      {{ __("forms.Question.Elements.question38.workflow_set") }}
                    </label>
                    <div v-for="wsr in workflow_set_roles_list" :key="wsr.id">
                      <span v-if="wsr.id == workflow_set_role_id">{{ wsr.name }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <label class="text-primary">
                      Workflow ruoli e persone
                    </label>
                    <div v-for="(wrp, k) in workflow_roles_people" :key="'k_' + k">

                      <span v-for="(wrl, j) in workflow_roles_list" :key="'wrl_' + j">
                        <span v-for="(wr, h) in wrl" :key="'wr_' + h">
                          <span v-if="wrp.workflow_role_id == wr.id">{{ wr.name }}</span>
                        </span>
                      </span>
                      |
                      <span v-for="(p, l) in people" :key="'p_' + l">
                        <span v-if="p.id == wrp.person_id">{{ p.fullName }}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {

  props: {
    can_write: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      textQuestion: '',
      //default
      title: "Multi Evaluators",
      active: false,
      action: "",
      name: "",
      description: "",
      sorting: -1,
      editing: true,
      people: [],
      useInSessions: [],
      alerts: null,
      canEdit: true,
      workflow_roles_people: [],
      multi_evaluators_group_list: [],
      workflow_set_roles_list: [],
      workflow_roles_list: [],
      workflow_set_role_id: null,
      multi_evaluators_group_id: null,
      new_workflow_role_id: null,
      new_person_id: null,

      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    }
  },
  methods: {

    deleteRow(index) {
      Vue.delete(this.workflow_roles_people, index);
    },

    addRelation() {
      if (this.new_person_id == null || this.new_workflow_role_id == null) {
        alert("Ci sono campi vuoti");
        return;
      }

      this.workflow_roles_people.push({
        person_id: this.new_person_id,
        workflow_role_id: this.new_workflow_role_id,
      })

    },

    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;

      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);

        }
        axios.get(dataRoute)
          .then((response) => {
            console.clear()
            console.log(response.data);
            this.name = response.data.base.name;
            this.description = response.data.base.description;
            this.sorting = response.data.base.sorting;
            this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
            this.multi_evaluators_group_id = response.data.multi_evaluators_group_id;
            this.workflow_set_role_id = response.data.workflow_set_role_id;
            this.workflow_roles_people = response.data.workflow_roles_people;
            this.workflow_roles_list = response.data.workflow_roles_list;
            this.people = response.data.people;
            this.alerts = response.data.alerts;
            this.canEdit = response.data.canEdit;
            this.useInSessions = response.data.useInSessions;

            this.workflow_set_roles_list = response.data.workflow_set_roles_list;
            this.multi_evaluators_group_list = response.data.multi_evaluators_group_list;
          });
      }
    }

  }

}
</script>
